var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2481 15.7795L18.1988 10.8859L18.1976 10.8851L19.5091 9.58876C21.497 7.62377 21.497 4.43841 19.5091 2.47343C17.5216 0.508854 14.2986 0.508854 12.3107 2.47343L10.9996 3.76976L9.689 2.47464C7.70109 0.509657 4.47855 0.509657 2.49063 2.47464C0.503123 4.43922 0.503123 7.62458 2.49063 9.58956L3.80168 10.8847L3.80127 10.8851L10.9992 18",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeing);
export default __webpack_public_path__ + "static/media/wellbeing.7c87aee7dffc19d65b759f7bfa4307b8.svg";
export { ForwardRef as ReactComponent };